import { Component } from '@angular/core';
import { ModalController, NavController, NavParams } from 'ionic-angular';
import { TakeawayServices } from '../services';
import { Globals } from '../../../globals';
import { TpvLoaderPage } from '../../tpv/tpv-loader/tpv-loader';
import { TakeawayOrderSelectPage } from '../takeaway-order-select/takeaway-order-select';
import { PopupSelectPayment } from '../../components/popups/popup-select-payment/popup-select-payment';


/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order',
  templateUrl: 'takeaway-order.html',
})
export class TakeawayOrderPage {




  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public modalCtrl: ModalController) {
    this.globals.GAtrackView('TakeAway', 'TakeAway - View', this.globals.restaurant.email, 'View', 'View takeaway', 'TakeAway', '');
    //getIndexByTableuid
    this.takeawayServices.getIndexByTableuid();
  }

  /**********************************************************/
  /*                          INIT                          */
  /**********************************************************/

  async ionViewWillEnter() {
    //getIndexByTableuid
    await this.takeawayServices.getIndexByTableuid();
    this.takeawayServices.customer.name = this.navParams.get('name') || this.takeawayServices.customer.name;
    this.takeawayServices.customer.business_name = this.navParams.get('business_name') || this.takeawayServices.customer.business_name;
    this.takeawayServices.customer.business_number = this.navParams.get('business_number') || this.takeawayServices.customer.business_number;
    this.takeawayServices.customer.email = this.navParams.get('email') || this.takeawayServices.customer.email;
    this.takeawayServices.customer.phone = this.navParams.get('phone') || this.takeawayServices.customer.phone;
    this.takeawayServices.customer.address = this.navParams.get('address') || this.takeawayServices.customer.address;
    this.takeawayServices.customer.note = this.navParams.get('note') || this.takeawayServices.customer.note;
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  back() {
    if (this.takeawayServices.quick_create) {
      this.takeawayServices.quick_create = false;
      this.globals.side_menu_active = 'tpv';
      this.navCtrl.setRoot(TpvLoaderPage);
      this.globals.tourLaunchStep(1);
    } else {
      this.navCtrl.pop();
    }
  }

  openPay() {
    //this.navCtrl.push(TakeawayOrderPayPage);
    let profileModal = this.modalCtrl.create(PopupSelectPayment,
      {
        table: this.takeawayServices.tables_array[this.takeawayServices.selected_table_tpv_index],
        origin: 'tk'

      });
    profileModal.onDidDismiss(data => {

    });
    profileModal.present();
  }

  openSelect() {
    this.takeawayServices.update_state = false;
    this.navCtrl.push(TakeawayOrderSelectPage);
  }

}




// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order.ts